import { isTMA } from '@tma.js/sdk-react'

/**
 * True when running inside Telegram (Mini App). Computed once at module load.
 * `isTMA()` (sync) returns true when Telegram launch params are present — the dev
 * mock-env provides them in DEV, and real Telegram provides them. In a plain
 * browser it is false → admin browser mode.
 *
 * The `?browser` URL flag forces browser mode in dev. We honor it here (not just
 * in mock-env) because @tma.js persists the mocked env in sessionStorage, so once
 * mocked `isTMA()` would keep returning true across reloads.
 */
export const isTelegram: boolean =
	typeof window !== 'undefined' &&
	isTMA() &&
	!new URLSearchParams(window.location.search).has('browser')
